import { SETTINGS_ROUTING_PAGES_SUBSCRIBE_ENABLED } from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsRoutingPages = () =>
    useSettingsFactory({
        subscribePageEnabled: { path: SETTINGS_ROUTING_PAGES_SUBSCRIBE_ENABLED },
    });
